<template>
  <the-section :title="$t('ec-line009.paymentTitle')" class="text-gray-950 text-base">
    <template #subTitle>
      <el-button class="section__button" @click="toPaymentPage">{{ $t('common.action.edit') }}</el-button>
    </template>
    <template #sub>
      <p class="mx-0 lg:mx-6 text-gray-950 text-base mt-2">
        {{ $t('ec-line009.paymentSubTitle') }}
      </p>
    </template>
    <template v-if="card_default">
      <el-row class="mb-5">
        <label class="text-body-01 required">{{ $t('common.memberInformation.paymentMethod') }}</label>
        <p class="text-body-02 ml-4 lg:ml-0">{{ data.payment_method }}</p>
      </el-row>

      <el-row
        type="flex"
        justify="space-between"
        align="middle"
        class="border border-solid border-gray-150 rounded-md p-4 mb-4"
      >
        <el-col class="text-body-01">{{ card_default.card_no }}</el-col>
        <el-col class="text-right text-body-02"
          >{{
            $t('common.cardExpired', { month: card_default.expire.slice(2), year: card_default.expire.slice(0, 2) })
          }}
        </el-col>
      </el-row>
    </template>

    <el-row v-else class="text-body-02">
      {{ $t('ec-line009.content.noPaymentMethod') }}
    </el-row>
  </the-section>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import { CARD_DEFAULT_FLAG } from '@/constants'

export default {
  components: { TheSection },
  props: {
    data: { type: Object, default: () => {} },
  },
  computed: {
    card_default() {
      return this.data.items?.find((i) => i.default_flag === CARD_DEFAULT_FLAG.DEFAULT) || this.data.items?.[0] || null
    },
  },
  methods: {
    toPaymentPage() {
      if (this.data.items.length) {
        this.$router.push(this.$routePage.EC_LINE012)
      } else {
        this.$router.push(this.$routePage.EC_LINE013_NEW)
      }
    },
  },
}
</script>

<style></style>
